export default class PropertyPriceConstants {
  static DEFAULT = 21;

  static POA = 1;
}
